/**
 * Constants for auto-apply functionality
 */

export const AUTO_APPLY_STORAGE_KEY = 'ai-mate-auto-apply-enabled';

export const FEATURE_GATE_KEY = 'enable_auto_apply_toggling';
